import { VoceSezione } from './voce-sezione';

export class RowSezione {
  vociCopertina: VoceSezione[];
  titleGroup: string;

  constructor( titleGroup: string, vociCopertina: VoceSezione[]) {
    this.titleGroup = titleGroup;
    this.vociCopertina = vociCopertina;
  }
}
